module.exports = __webpack_public_path__ + "static/media/turn.26255bd8.ogg";